import axios from "axios";
import { API, API_V2 } from "../urls";

export const sourcesService = {
  getSources,
  getSubscriptions,
  getSwissPedDoseDetails,
  ApproveSource,
  UnSubscribeSource,
  subscribe,
  subscriptioncomment,
  getComments,
  tracker,
  professions,
  professionalArea
};

function professionalArea(){
  return axios.get(API.professionalAreaLocation.toUrl());
}
function professions(){
  return axios.get(API.professionsLocation.toUrl());
}
function subscriptioncomment(data){
  return axios.post(API.subscriptioncomment.toUrl(),data);
}
function subscribe(data){
  return axios.post(API.subscribe.toUrl(),data);
}
function getSources() {
  return axios.get(API_V2.sourcesLocation.toUrl());
}
async function getSwissPedDoseDetails (id) {
  return await axios.get(API.swissPedDoseDetailsLocation.toUrl({
    id: id
  }));
}
function getComments() {
  return axios.get(API.getComments.toUrl());
}
function getSubscriptions(data) {
  return axios.get(API.suscriptionsLocation.toUrl());
}
function tracker(id) {
  return axios.get(id)
}
function ApproveSource(id) {
    let url = API.approveSourceLocation.toUrl({ id });
    return axios.put(url)
}

function UnSubscribeSource(data) {
  return axios.post(API.unsubscribeLocation.toUrl(), data)
}
